import { ErrorResponse, UserRequestDto } from '@gtpl/shared-models/common-models';
import { AllRejectionReasonsResponse, GrnRejectionReasonResponse } from '@gtpl/shared-models/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { Repository } from 'typeorm';
import { GrnRejectionReasonAdapter } from './dto/grn-rejection-reason.adapter';
import { RejectioRreasonRequest } from './dto/grn-rejection-reason.request';
import { RejectionReasonsDto } from './dto/grn-rejection-reasons.dto';
import { GrnRejectionReason } from './grn-rejection-reason.entity';

@Injectable()
export class GrnRejectionReasonsService {
    constructor(
      private logService:LogsService,
        @InjectRepository(GrnRejectionReason) private GrnrejReasonRepository: Repository<GrnRejectionReason>,
        private GrnRejReasonAdapter: GrnRejectionReasonAdapter,
      ) { }

      async createGrnRejectionReason(grnRejReasondto:RejectionReasonsDto, isUpdate: boolean,request:Request): Promise<GrnRejectionReasonResponse> {
        try {
        let previousValue
        if (!isUpdate) {
            const grnRejReasonEntity = await this.getGrnRejReason(grnRejReasondto.rejectionReasonCode);
          if (grnRejReasonEntity) {
            throw new GrnRejectionReasonResponse(false,11104, 'GRN rejction reason already exists');
          }
        }
        else{
            const previous = await this.GrnrejReasonRepository.findOne({where:{rejectionReasonId:grnRejReasondto.rejectionReasonId}})
            previousValue = previous.rejectionReasonCode+','+previous.rejectionReason
            const grnRejReasonEntity = await this.getGrnRejReason(grnRejReasondto.rejectionReasonCode);
            if (grnRejReasonEntity) {
                if(grnRejReasonEntity.rejectionReasonId!=grnRejReasondto.rejectionReasonId){
                    throw new GrnRejectionReasonResponse(false,11104, 'GRN rejction reason already exists');
                }
            }
        }
        const convertedgrnRejReasonEntity: GrnRejectionReason = this.GrnRejReasonAdapter.convertDtoToEntity(grnRejReasondto,isUpdate);
        const savedgrnRejReasonEntity: GrnRejectionReason = await this.GrnrejReasonRepository.save(convertedgrnRejReasonEntity);
        const savedgrnRejReasonDto: RejectionReasonsDto = this.GrnRejReasonAdapter.convertEntityToDto(savedgrnRejReasonEntity);
       
         if (savedgrnRejReasonDto) {
        const presentValue = savedgrnRejReasonDto.rejectionReasonCode+","+savedgrnRejReasonDto.rejectionReason
          const response = new GrnRejectionReasonResponse(true,isUpdate ? 11100 : 11101,isUpdate? 'GRN rejction reason Updated Successfully':'GRN rejction reason Created Successfully',savedgrnRejReasonDto);
          const name=isUpdate?'updated':'created'
          const displayValue = isUpdate? 'GRN rejction reason Updated Successfully': 'GRN rejction reason Created Successfully'
          const userName = isUpdate?savedgrnRejReasonDto.updatedUser:savedgrnRejReasonDto.createdUser
          const newLogDto = new LogsDto(1,name, 'GrnRejectionReason', savedgrnRejReasonDto.rejectionReasonId, true, displayValue,userName,previousValue,presentValue)
          let res = await this.logService.createLog(newLogDto);
          console.log(res);
          return response;
        } else {
          throw new GrnRejectionReasonResponse(false,11106,'GRN rejction reason saved but issue while transforming into DTO');
        }
      }
      catch (error) {
        return error;
      }
    }
    /**
     * gets all grn rejection reason details  
     * @returns all thegrn rejection reason details .
     */
    // @LogActions({ isAsync: true })
    async getAllGrnRejectionReasons(req?:UserRequestDto): Promise<AllRejectionReasonsResponse> {  
        try {
            const grnRejReasonDto: RejectionReasonsDto[] = [];
            // retrieves all plants
            const grnRejReasonEntities: GrnRejectionReason[] = await this.GrnrejReasonRepository.find({
                order: { rejectionReason: "ASC" },
            });
            //   console.log(grnRejReasonEntities);
            if (grnRejReasonEntities.length>0) {
                grnRejReasonEntities.forEach(GrnRejReasonEntity => {
                const convertedgrnRejReasonDto: RejectionReasonsDto = this.GrnRejReasonAdapter.convertEntityToDto(GrnRejReasonEntity);
                grnRejReasonDto.push(convertedgrnRejReasonDto);
                });
                const response = new AllRejectionReasonsResponse(true, 11208, "GRN rejection reasons retrieved successfully", grnRejReasonDto);
                if(req?.createdUser){
                    const newLogDto = new LogsDto(1,'view', 'GrnRejectionReason', 0, true, 'GRN rejection reasons retrieved successfully',req.createdUser,'','')
                    let res = await this.logService.createLog(newLogDto);
                    console.log(res);
                }
 
                return response;
            } else {
                //   console.log('yest')
                throw new GrnRejectionReasonResponse(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getGrnRejReason(rejectionReasonCode: string): Promise<GrnRejectionReason> {
        //  console.log(employeeId);
            const response = await this.GrnrejReasonRepository.findOne({
            where: {rejectionReasonCode: rejectionReasonCode},
            });
            // console.log(response);
            if (response) {
            return response;
            } else {
            return null;
            }
        }

    /**
     * It deactivates value  Grn Rejection Reason   
     * @param itemReq   Grn Rejection Reason  as string
     * @returns true or false
     */
    // @LogActions({isAsync: true})
    async activateOrDeactivateGrnRejectionReason(rejReasonReq: RejectioRreasonRequest): Promise<GrnRejectionReasonResponse> {
        try {
            const rejReasonsExists = await this.getGrnRejReasonById(rejReasonReq.rejectionReasonId);
            if (rejReasonsExists) {
                if (rejReasonReq.versionFlag !== rejReasonsExists.versionFlag) {
                    throw new GrnRejectionReasonResponse(false,10113, 'Someone updated the current GRN rejection reason information.Refresh and try again');
                } else {
                    
                        const rejReasonSatatus =  await this.GrnrejReasonRepository.update(
                            { rejectionReasonId: rejReasonReq.rejectionReasonId },
                            { isActive: rejReasonReq.isActive,updatedUser: rejReasonReq.updatedUser });
                       
                        if (rejReasonsExists.isActive) {
                            if (rejReasonSatatus.affected) {
                                const grnRejReasonsResponse: GrnRejectionReasonResponse = new GrnRejectionReasonResponse(true, 10115, 'GRN Rejection reason is de-activated successfully');
                                return grnRejReasonsResponse;
                            } else {
                                throw new GrnRejectionReasonResponse(false,10111, 'GRN Rejection reason is already deactivated');
                            }
                        } else {
                            if (rejReasonSatatus.affected) {
                                const grnRejReasonsResponse: GrnRejectionReasonResponse = new GrnRejectionReasonResponse(true, 10114, 'GRN Rejection reason is activated successfully');
                                return grnRejReasonsResponse;
                            } else {
                                throw new GrnRejectionReasonResponse(false,10112, 'GRN Rejection reason is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new GrnRejectionReasonResponse(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getGrnRejReasonById(rejectionReasonId: number): Promise<GrnRejectionReason> {
    //  console.log(employeeId);
        const response = await this.GrnrejReasonRepository.findOne({
        where: {rejectionReasonId: rejectionReasonId},
        });
        // console.log(employeeresponse);
        if (response) {
        return response;
        } else {
        return null;
        }
    }
}
